import { render, staticRenderFns } from "./Reaction.vue?vue&type=template&id=541f042c&"
import script from "./Reaction.vue?vue&type=script&lang=js&"
export * from "./Reaction.vue?vue&type=script&lang=js&"
import style0 from "./Reaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports